import { observable, action, flow, computed, toJS } from 'mobx';
import { rstr2b64 } from 'utils/md5';
import Util from 'utils';
import Config from 'config/Config';
import { Modal, Toast } from 'antd-mobile';
import Stores from 'config/Stores';
import Serv from './MsgAddServ';
const member_userInfo = Util.getLocalCache(Config.localStorageKeys.member_userInfo) || {};

class MsgAddMod {
  @observable memberId = '';
  // 性别
  @observable sex = 0;
  // 出生日期
  @observable birthday = '';
  @observable cardCode = Stores.AppMod.userInfo.cardCode || '';
  // 证件类型数字字典
  @observable cardType = [];
  // 选择的证件类型
  @observable identityType = '';

  @observable identityCard = '';
  @observable errorMessage = '';
  @observable errorStatus = 0;
  // 当前是否强制验证身份证
  @observable examine = 0;
  // 身份证号、身份证号是否可编辑
  @observable certNum = '';

  @observable certNumEditable = true;
  @observable realNameEditable = true;
  // 身份证正反面
  @observable imgList = [];

  @observable imgListEditable = true;

  // 银行地址
  @observable bankAddress = null;

  @observable bankAddressEditable = true;

  // 开户银行
  @observable headBankId = '';

  @observable headBankName = '';

  @observable headBankIdEditable = true;

  // 支行信息
  @observable branchBankId = '';

  @observable branchBankIdEditable = true;

  // 支行名称
  @observable branchBankName = '';

  // 银行账号
  @observable bankNum = '';

  @observable bankNumEditable = true;

  // 收件人
  @observable deliveryName = '';

  @observable deliveryNameEditable = true;
  @observable realName = '';
  // 手机号
  @observable phone = '';

  @observable phoneEditable = true;

  // 收货地址
  @observable deliveryAddress = null;

  @observable deliveryAddressEditable = true;

  // 详细地址
  @observable detailAddress = '';

  @observable detailAddressEditable = true;

  // 银行总行列表
  @observable headBankList = [];

  // 支行列表
  @observable branchBankList = [];
  @observable nationList = [];

  // 支行搜索关坚词
  @observable bankKeyword = '';

  @observable accumulate = 0;

  @observable nation = '';
  // 会员结算状态 0未结算 1已结算
  @observable settlementStatus = 1;
  // 是否是代课过来的
  @observable isDG = false;

  // 是否必填，由外部传入
  @observable isRequire = false;
  // 被代客的用户的健康顾问信息
  userInfoData = {};
  // 手机号码区号
  areaCode = 86;

  // 选择的地址信息
  @observable addressInfo = {};

  @observable hideName = false;

  // 是否同意协议
  @observable isAgree = false;

  /**
   * 修改参数逻辑
   */
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 重置数据
   */
  @action
  resetData() {
    this.memberId = '';
    this.certNum = '';
    this.realName = '';
    this.certNumEditable = true;
    this.realNameEditable = true;
    this.imgList = ['', ''];
    this.imgListEditable = true;
    this.bankAddress = null;
    this.bankAddressEditable = true;
    this.headBankId = '';
    this.headBankIdEditable = true;
    this.branchBankId = '';
    this.branchBankIdEditable = true;
    this.branchBankName = '';
    this.bankNum = '';
    this.bankNumEditable = true;
    this.deliveryName = '';
    this.deliveryNameEditable = true;
    this.phone = '';
    this.phoneEditable = true;
    this.deliveryAddress = null;
    this.deliveryAddressEditable = true;
    this.detailAddress = '';
    this.detailAddressEditable = true;
    // this.headBankList = [];
    this.branchBankList = [];
    this.bankKeyword = '';
    this.bankKeyword = '';
    this.settlementStatus = 1;
    this.isAgree = false;
  }

  /**
   * 证件类型
   */
  getCardType = flow(function* () {
    try {
      const { data } = yield Serv.queryIdCardTypeList(this.cardCode);
      this.cardType = (data || []).map((item) => {
        if (item.value == 4 && window.currentLng == 'cn' && Stores.AppMod.isInternationalized) {
          item.label = '其他国家证件';
        }
        return item;
      });
    } catch (error) {}
  });

  /**
   * 查询会员信息
   */
  queryLoseInfo = flow(function* () {
    try {
      const { data, resultCode, resultMsg } = yield Serv.queryLoseInfo(this.cardCode);

      if (resultCode != 0) {
        if (resultMsg && resultMsg.indexOf('越权查询') == -1) {
          Toast.info(resultMsg);
        }
        return;
      }
      this.certNum = +data.identityCardType === 1 ? data.identityCard || '' : '';
      this.realName = data.realName || '';
      this.realNameEditable = !this.realName;
      this.identityCard = data.identityCard;
      if (data.identityCardType) {
        this.identityType = data.identityCardType;
      }
      this.certNumEditable =
        !this.certNum || (this.certNum.length != 15 && this.certNum.length != 18);

      // this.imgList = [data.positiveUrl || '', data.reverseSideUrl || ''];
      this.imgListEditable = !data.positiveUrl || !data.reverseSideUrl;

      if (data.provinceCode && data.cityCode) {
        this.bankAddress = [
          {
            label: data.provinceName,
            value: data.provinceCode
          },
          {
            label: data.cityName,
            value: data.cityCode
          }
        ];
        this.bankAddressEditable = !data.branchCode;
      }

      if (data.bankId || data.bankId === 0) {
        this.headBankId = data.bankId;
        this.headBankIdEditable = !data.branchCode;
      }

      if (this.bankAddress && `${this.headBankId}` && (data.branchCode || data.branchCode === 0)) {
        this.branchBankId = data.branchCode;
        this.branchBankName = data.branchName;
        this.branchBankIdEditable = false;
      }

      this.bankNum = data.bankAccount || '';
      this.bankNumEditable =
        !data.bankAccount ||
        this.bankAddressEditable ||
        this.headBankIdEditable ||
        this.branchBankIdEditable;

      this.deliveryName = data.contact || '';
      this.deliveryNameEditable = !data.contact;

      this.phone = data.phone || '';
      this.phoneEditable = !data.phone;

      if (data.shipProvinceCode && data.shipCityCode && data.shipDistrictCode) {
        this.deliveryAddress = [
          {
            label: data.shipProvinceName,
            value: data.shipProvinceCode
          },
          {
            label: data.shipCityName,
            value: data.shipCityCode
          },
          {
            label: data.shipDistrictName,
            value: data.shipDistrictCode
          },
          {
            label: data.shipStreetName,
            value: data.shipStreetCode
          }
        ].filter((e) => e.label);
        this.deliveryAddressEditable = !data.detailAddr;
      }

      this.detailAddress = data.detailAddr || '';
      this.detailAddressEditable =
        this.deliveryAddressEditable || (data.detailAddr || '').length < 7;
      this.settlementStatus = data.settlementStatus;
      this.areaCode = data.areaCode || 86;
      this.addressInfo = data;
      return data;
    } catch (error) {
      return null;
    }
  });

  setAddInfo = (data) => {
    this.addressInfo = data;
    this.deliveryName = data.contact || '';
    this.deliveryNameEditable = !data.contact;
    this.phone = data.phone || '';
    this.areaCode = data.areaCode || 86;
    this.phoneEditable = !data.phone;

    if (data.provinceCode && data.cityCode) {
      this.deliveryAddress = [
        {
          label: data.province,
          value: data.provinceCode
        },
        {
          label: data.city,
          value: data.cityCode
        },
        {
          label: data.district,
          value: data.districtCode
        },
        {
          label: data.street,
          value: data.streetCode
        }
      ].filter((e) => e.label);
      this.deliveryAddressEditable = !data.detailAddr;
    }
    this.detailAddress = data.detailAddr || '';
    this.detailAddressEditable = this.deliveryAddressEditable || (data.detailAddr || '').length < 7;
  };

  queryUserIdByCardCode = flow(function* () {
    try {
      const { data } = yield Serv.queryUserIdByCardCode(this.cardCode);
      this.memberId = data;
    } catch (error) {}
  });

  /**
   * 获取银行总行列表
   */
  getHeadBankList = flow(function* () {
    try {
      const { data } = yield Serv.getHeadBankList();
      if (Array.isArray(data)) {
        this.headBankList = data.map((_val) => ({
          label: _val.name,
          value: `${_val.id}`,
          name: _val.name
        }));
      }
    } catch (error) {}
  });

  /**
   * 下一步
   */
  saveUserInfo = flow(function* (accumulate, remindTag) {
    // if (this.detailAddress != '' && this.detailAddress.length < 7) {
    //   Toast.info('详细地址长度不可少于7位');
    //   return;
    // }
    // 乘星吻月站点不需要填写银行卡和收获地址
    // if (
    //   !Stores.AppMod.isCXY &&
    //   !this.isDG &&
    //   !accumulate &&
    //   this.bankNum.length != 16 &&
    //   this.bankNum.length != 19 &&
    //   this.bankNum.indexOf('*') == -1
    // ) {
    //   Toast.info('银行卡账号长度需等于16或19位');
    //   return;
    // }
    let bankName = ''; // 主行名称
    this.headBankList.find((item) => {
      if (item.value == this.headBankId) {
        bankName = item.name;
        return true;
      }
    });

    // 判断是否正确的手机号
    if (!Util.checkInput(this.phone, 'mobile') && !!this.phone) {
      Toast.info('请检查手机号是否正确');
      return;
    }

    // 判断是否正确的银行卡号
    // if (
    //   !Util.checkInput(this.bankNum, 'bank') &&
    //   !!this.bankNum &&
    //   this.bankNum.indexOf('*') == -1
    // ) {
    //   Toast.info('请检查是否是16或者19位银行卡号');
    //   return;
    // }
    const address = [
      {
        key: 'shipProvinceCode',
        value: 'shipProvinceName'
      },
      {
        key: 'shipCityCode',
        value: 'shipCityName'
      },
      {
        key: 'shipDistrictCode',
        value: 'shipDistrictName'
      },
      {
        key: 'shipStreetCode',
        value: 'shipStreetName'
      }
    ];
    const addressObj = {};
    const deliveryArr = this.deliveryAddress || [];
    deliveryArr.forEach((e, i) => {
      addressObj[address[i].key] = e.value || '';
      addressObj[address[i].value] = e.label || '';
    });
    // 补充未选到的级别字段为空字符串（选了"暂不选择"时数组会截断）
    for (let i = deliveryArr.length; i < address.length; i++) {
      addressObj[address[i].key] = '';
      addressObj[address[i].value] = '';
    }
    let params = {
      nation: this.nation,
      cardCode: this.cardCode,
      identityType: this.identityType,
      identityCard: this.certNum,
      positiveUrl: this.imgList[0],
      reverseSideUrl: this.imgList[1],
      provinceCode: this.bankAddress && this.bankAddress[0] ? this.bankAddress[0].value : '',
      cityCode: this.bankAddress ? this.bankAddress[1].value : '',
      realName: this.realName,
      bankName,
      branchCode: this.branchBankId,
      bankAccount: this.bankNum,
      contact: this.deliveryName,
      phone: this.phone,
      // cardType: this.cardTypeValue,
      sex: this.sex,
      birthday: this.birthday,
      ...addressObj,
      // shipProvinceCode: this.deliveryAddress
      //   ? this.deliveryAddress[0].value
      //   : '',
      // shipCityCode: this.deliveryAddress ? this.deliveryAddress[1].value : '',
      // shipDistrictCode: this.deliveryAddress
      //   ? this.deliveryAddress[2].value
      //   : '',
      detailAddr: this.detailAddress,
      areaCode: this.areaCode
    };
    // console.log(params,'---->params');
    // return
    if (!!params.identityCard && params.identityCard.indexOf('*') != -1) {
      // 解密身份证
      params.identityCard = yield Stores.AppMod.getDecyptMsg({
        id: Stores.AppMod.userInfo.id || '',
        scene: '001',
        channel: ''
      });
    }
    if (!!params.realName && params.realName.indexOf('*') != -1) {
      // 解密姓名
      params.realName = yield Stores.AppMod.getDecyptMsg({
        cardCode: this.cardCode || Stores.AppMod.userInfo.cardCode || '',
        scene: 101,
        channel: ''
      });
    }
    if (!!params.phone && params.phone.indexOf('*') != -1) {
      // 解密手机号
      params.phone = yield Stores.AppMod.getDecyptMsg({
        id: this.memberId || Stores.AppMod.userInfo.id || '',
        scene: 206,
        channel: ''
      });
    }

    try {
      if (accumulate) {
        // 提交累计制的补充信息
        const userId = Stores.AppMod.userInfo.id;
        const { saleConsultantCardCode = '8888888888' } = member_userInfo || {};
        const { resultCode, data, resultMsg } = yield Serv.saveAccoumulateUserInfo(
          { ...params, userId, identityType: this.identityType },
          remindTag
        );
        if (resultCode == 17541) {
          // 银行账户的会员绑定上限
          Modal.alert('温馨提示', resultMsg || (data && data.msg), [
            {
              text: '我已知晓',
              onPress: () => {
                this.changeState({ bankNum: '', branchBankName: '', branchBankId: '' });
                Toast.hide();
              }
            }
          ]);
          return false;
        } else {
          return data;
        }
      } else {
        const { data } = yield Serv.saveUserInfo(params);
        const applyStoreMsg =
          Util.getLocalCache(Config.localStorageKeys.member_applyStoreMsg) || {};
        Util.setLocalCache(Config.localStorageKeys.member_applyStoreMsg, {
          ...applyStoreMsg,
          registerCardReqDto: {
            ...applyStoreMsg.registerCardReqDto,
            identityCard: this.certNum
          }
        });
      }
      return true;
    } catch (error) {
      console.log('😛====>', error);
      return false;
    }
  });

  @computed
  get newBankList() {
    let newBankList = this.branchBankList
      .filter((bank) => bank.name.indexOf(this.bankKeyword) != -1)
      .map((bank) => ({ label: bank.name, value: `${bank.code}` }));
    if (newBankList.length == 0) {
      newBankList = [{ label: '无支行信息', value: 'none' }];
    }
    return newBankList;
  }

  /**
   * 获取民族列表
   */
  getNationList = flow(function* (memberNum) {
    try {
      const { data } = yield Serv.getNationList({ cardCode: memberNum });
      if (Array.isArray(data)) {
        this.nationList = data.map((_val) => ({
          label: _val.name,
          value: _val.id
        }));
      }
    } catch (error) {}
  });

  /**
   * @description 根据卡号获取健康顾问的卡号和信息
   * @memberof MsgAddMod
   */
  getUserInfoByCardCode = flow(function* (cardCode) {
    try {
      const { data } = yield Serv.getUserInfoByCardCode({ cardCode });
      this.userInfoData = data;
    } catch (error) {
      console.log(error);
    }
  });

  verifyMemberCardValid = flow(function* () {
    try {
      const { data, resultCode } = yield Serv.verifyMemberCardValid();
      if (data) {
        return data;
      } else {
        return false;
      }
    } catch (error) {}
  });
  // 归属人是否为新加坡账号
  @computed
  get isSingapore() {
    if (this.isDG) {
      const memberData = Util.getLocalCache(Config.localStorageKeys.store_agentUpgradeMember);
      return memberData && memberData.areaCode === '65';
    } else {
      const userInfo = Stores.AppMod.userInfo || {};
      return userInfo.areaCode === '65';
    }
  }

  @computed
  get disabled() {
    let fullCertMsg = this.isSingapore || !!this.certNum;
    let fullName = !!this.realName;
    if (this.hideName) {
      fullName = true;
    }
    let fullBankMsg =
      !!this.bankAddress && !!`${this.headBankId}` && !!`${this.branchBankId}` && !!this.bankNum;
    // let fullDeliveryMsg = !!this.deliveryName && !!this.phone && !!this.deliveryAddress && !!this.detailAddress;
    // console.log(123, fullCertMsg, fullBankMsg, fullDeliveryMsg)
    if (this.isRequire) {
      return !fullBankMsg || !fullName || !this.certNum;
    }
    // 乘星吻月站点不需要填写银行卡和收获地址
    if (this.accumulate || Stores.AppMod.isCXY) {
      return !fullCertMsg || !fullName;
    }
    // 地址跟银行都改成非必填
    // let fullBankMsg = this.isDG
    //   ? true
    //   : !!this.bankAddress && !!`${this.headBankId}` && !!`${this.branchBankId}` && !!this.bankNum;
    // let fullDeliveryMsg =
    //   !!this.deliveryName && !!this.phone && !!this.deliveryAddress && !!this.detailAddress;
    return !fullCertMsg || !fullName;
  }

  /**
   * 获取店铺类型列表
   */
  getStoreTypeList = flow(function* (isPartner = false) {
    try {
      const { healthConsultantNum } = Stores.AppMod.userInfo || {};
      const params = {
        configure: 1,
        healthCode: healthConsultantNum,
        jointCreationTag: isPartner ? 1 : 0
      };
      let { data } = yield Serv.getStoreTypeList(params);
      if (Array.isArray(data)) {
        data = data.map((item) => {
          // storeName 0 对外名称 1 开店政策
          const { storeName, typeName, externalName } = item;
          return {
            ...item,
            typeName: storeName === 0 ? externalName : typeName
          };
        });
        return data;
      }
      return [];
    } catch (error) {
      console.log('dshjkhdakj===>', error);
      return [];
    }
  });

  /**
   * 获取区域配置情况
   *
   * @memberof PersonalMod
   */
  getRegionConfiguration = flow(function* (typeId) {
    try {
      const { data } = yield Serv.getRegionConfiguration({ typeId });
      if (data) {
        return data;
      }
      return false;
    } catch (error) {
      return false;
    }
  });

  /**
   * 腾晖云仓订单，调用submit接口
   *
   * @memberof MemGiftbagMod
   */
  addTHUpgradeOrder = flow(function* () {
    const submitUrl = 'user/upgrade/submitUpgradeCardOrder';
    const submitParams =
      Util.getLocalCache(Config.localStorageKeys.th_cloud_upgrade_submit_params) || {};
    submitParams.confirmReqId = Util.getLocalCache(Config.localStorageKeys.confirm_req_id) || ''; // 开卡、升级下单慢接口优化加传

    try {
      Toast.loading('请稍候', 100);
      const { data: submitData } = yield Serv.addOrder(submitUrl, submitParams);
      Toast.hide();
      if (submitData) {
        Util.setLocalCache(Config.localStorageKeys.confirm_req_id, ''); // 清除缓存
        const tradeNo = typeof data === 'object' ? submitData.tradeNo : submitData;
        window.app.routerRedirect(`/shop/payMent/${tradeNo}`);
      }
      return true;
    } catch (err) {
      console.log('dashjkhkda===>', err);
      return true;
    }
  });

  // 保存合同签订记录
  setContractSign = flow(function* (params) {
    try {
      const { data } = yield Serv.setContractSign(params);
      return data;
    } catch (error) {
      console.log('error===>setContractSign', error);
    }
  });

  /**
   * 获取订单类型列表,根据卡号查询订单类型名称
   */
  getOrderTypeList = flow(function* (cardCode) {
    try {
      const { data: orderLabelResult } = yield Serv.queryOrderTypeInfo({
        cardCode,
        saleMode: ''
      });

      let orderTypeList = [];

      if (orderLabelResult) {
        const { retailName = '', vipName = '', retailOrder = 0, vipOrder = 0 } = orderLabelResult;
        if (retailOrder) {
          orderTypeList.push({ label: retailName || '零售订单', value: 1 });
        }
        if (vipOrder) {
          orderTypeList.push({ label: vipName || '复消订单', value: 2 });
        }
      } else {
        orderTypeList = [
          { label: '零售订单', value: 1 },
          { label: '复消订单', value: 2 }
        ];
      }
      return orderTypeList;
    } catch (error) {
      console.log('error===>getOrderTypeList', error);
      return [];
    }
  });
}
const msgAddMod = new MsgAddMod();
export default msgAddMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/MsgAdd/MsgAddMod.js